import { FileLog } from "./file";
import { UnitDTO } from "./unit";

export enum DeviceType {
    OVEN = "Oven",
    MICROWAVE = "Microgolfoven",
    COMBI_OVEN = "Combi-oven",
    DISHWASHER = "Vaatwasmachine",
    REFRIGERATOR_WITH_FREEZER = "Koelkast met vriesvak",
    REFRIGERATOR_NO_FREEZER = "Koelkast zonder vriesvak",
    HOB_INDUCTION_WITH_EXTRACTOR_HOOD = "Kookplaat inductie met ingebouwde dampkap",
    HOB_INDUCTION = "Kookplaat inductie",
    HOB_ELECTRICAL = "Kookplaat elektrisch",
    HOB_CERAMIC = "Kookplaat keramisch",
    HOB_GAS = "Kookplaat gas",
    WASHMACHINE = "Wasmachine",
    DRYER = "Droogkast",
    EXTRACTOR_HOOD = "Dampkap",
    // ... add other common devices ...
}

export enum EnergyLabel {
    A_PLUS = "A+",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",
    G = "G"

    // ... add more as needed ...
}

export type Device = {
    id?: number;
    deviceType: DeviceType | null;
    energyLabel: EnergyLabel | null;
    devicePicturesFileLogIds: number[] | null;
    width: number | null;
    height: number | null;
    depth: number | null;
    technicalFicheFileLogId: number | null;
    technicalFicheFileLog: FileLog | null;
    invoiceFileLogId: number | null;
    invoiceFileLog: FileLog | null;
    dbValue: number | null; // sounds (e.g. 35dB)
    description: string | null;
    brand: string | null;
    model: string | null;
    serialNumber: string | null;
    location: string | null; 
    installationDate: Date | null;
    unit: UnitDTO;
    room?: any; // This is optional as you might not always know the room
}